import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useCancellationToken from 'utils/customHook/useCancellationToken';
import { StatusIconContainer } from './StatusComponentIcon.css.js';
import IconsAlignArea from './IconsAlignArea';
import StatusIcon from './StatusIcon';

const StatusComponentIcon = (props) => {
  const cancellationToken = useCancellationToken();
  const dispatch = useDispatch();
  const [iconData, setIconData] = useState(null);
  const [flag, setFlag] = useState(props.settings.setting.flag_ch4_hc); //
  const gasLog = useSelector((store) => store.gasLog);
  const noneModuleTerm = useSelector((store) => store.settings).setting.noneModuleTerm;

  useEffect(() => {
    if (cancellationToken.isCancelled) {
      return;
    }

    if (gasLog.status === 'SUCCESS') {
      const dangerStatusModuleIndex = gasLog.gas.findIndex((gas) => gas.status === 'danger' || gas.status === 'warning');

      if (dangerStatusModuleIndex === -1) {
        dispatch({ type: 'ALERT_OFF' });
      }

      setIconData(gasLog.gas);
    }
  }, [noneModuleTerm, gasLog]);

  useEffect(() => () => cancellationToken.cancel(), []);

  if (!iconData) {
    return <StatusIconContainer></StatusIconContainer>;
  }

  return (
    <>
      {props.alignOption === 'area' ? (
        <IconsAlignArea iconData={iconData} />
      ) : (
        <StatusIconContainer alignOption={props.alignOption}>
          {iconData.map((data) => {
            return <StatusIcon key={`${data.title}_${data.moduleIdx}`} alignOption={props.alignOption} count={iconData.length} flag={flag} {...data} />;
          })}
        </StatusIconContainer>
      )}
    </>
  );
};

export default StatusComponentIcon;
